module.exports = __webpack_public_path__ + "media/components/country-flag/static/gl-c616c5a311ba22ef3d33249dcb124e0f.svg";